import { getTokenIn } from "@/utils/cookies"
import router from "@/router"
import { getUserDetailAPi, msgSecCheckAPi } from "@/api/login"
import { showNotify, showLoadingToast, closeToast, showConfirmDialog, showToast } from "vant"
import { getModules } from "@/modules/arcgisAPI"

// 是否登录=>认证
const isLoginIsAuthentication = (e: string, success: any) => {
  if (!getTokenIn()) {
    showConfirmDialog({
      // title: "标题",
      message: "当前服务需要登录并认证之后才可以正常使用! 去登录>>",
      confirmButtonText: "确认"
    }).then(() => {
      //未登录情况需要 跳转到个人中心首页
      router.push({ path: "/user", query: { from: "resource" } })
    })
  } else {
    // 已经登录需要判断账号类型以及是否认证
    getUserDetail(e, success)
  }
}
// 获取用户基本信息
const getUserDetail: any = (e: string, success: any) => {
  getUserDetailAPi().then((res: any) => {
    if (res.code == 200) {
      isAuthentication(res.data, e, success)
    } else {
      showNotify({ type: "danger", message: res.message || "服务器错误" })
    }
  })
}
// 判断是否认证
const isAuthentication = (userDetail: any, e: string, success: any) => {
  const flag = userDetail?.authenticationStatus //认证判断的字段
  const type = userDetail?.accountType //账号类型
  if (flag == "uncheck") {
    if (e == "showConfirmDialog") {
      showConfirmDialog({
        message: "当前服务需要进行认证之后才可以正常使用! 去认证>>",
        confirmButtonText: "确认"
      }).then(() => {
        //未登录情况需要 跳转到个人中心首页
        if (type == "personnel") {
          router.push({ path: "/authenticationPerson" })
        } else if (type == "enterprise") {
          router.push({ path: "/authenticationCompany" })
        }
      })
    } else if (flag == "checked") {
      //未登录情况需要 跳转到个人中心首页
      if (type == "personnel") {
        router.push({ path: "/authenticationPerson" })
      } else if (type == "enterprise") {
        router.push({ path: "/authenticationCompany" })
      }
    }
  } else {
    // 已经认证
    success()
  }
}
// 下载附件
const downloadAttachment = (id: any, fileName: any) => {
  if (id && fileName) {
    const urls = "/updt-file/api/v1/file-contents/download?sfid=" + id
    console.log("附件下载的链接：")
    // window.location.href = urls
    router.push({ path: "/webView", query: { url: urls, sfid: id, fullfilename: fileName } })
  } else {
    showNotify({ type: "danger", message: "下载地址错误" })
  }
  // window.open(url)
  // window.location.href = urls
  //router.push({ path: "/webView", query: { url: urls } })
  // wx.miniProgram.navigateTo({
  //   url: url
  // })
}
const beforeReadImg = (file: any) => {
  if (Array.isArray(file)) {
    showToast("请按照要求一次只能上传一张图片")
    return false
  } else {
    return true
  }
}
const beforeReadFile = (file: any) => {
  if (Array.isArray(file)) {
    showToast("请按照要求一次只能上传一个文件")
    return false
  } else {
    return true
  }
}
// 安全检测
const errorList = () => {
  const errorList = [
    {
      label: "正常",
      value: 100
    },
    {
      label: "广告",
      value: 10001
    },
    {
      label: "时政",
      value: 20001
    },
    {
      label: "色情",
      value: 20002
    },
    {
      label: "辱骂",
      value: 20003
    },
    {
      label: "违法犯罪",
      value: 20006
    },
    {
      label: "欺诈",
      value: 20008
    },
    {
      label: "低俗",
      value: 20012
    },
    {
      label: "版权",
      value: 20013
    },
    {
      label: "其他",
      value: 21000
    }
  ]
  return errorList
}
const secureCheck = async (data: any) => {
  console.log(errorList())
  showLoadingToast({
    message: "安全检测中",
    duration: 0
  })
  const datas: any = await msgSecCheckAPi(data)
  if (datas.code == 200) {
    closeToast()
    if (datas.data.suggest == "pass") {
      return datas
    } else {
      showToast("包含不符合相关规定的敏感信息！！！")
      return datas
    }
  } else {
    closeToast()
    showNotify({ type: "danger", message: datas.message })
    return datas
  }
}
// 登录认证T026参数控制
const setT026 = () => {
  const appid = (window as any).appid
  return appid
}

export const queryTask = async (url: string, params: any) => {
  const [QueryTask, Query] = await getModules(["esri/tasks/QueryTask", "esri/tasks/support/Query"])
  return new Promise((resolve, reject) => {
    const queryTask = new QueryTask({
      url
    })
    const queryParams = new Query(params)
    queryTask
      .execute(queryParams)
      .then((res: any) => {
        if (res && res.features) resolve(res.features)
      })
      .catch((err: any) => {
        console.log(err)
        reject(false)
      })
  })
}
// 扩展面范围
export const changeExtent = (extent: any) => {
  const x = extent.xmax - extent.xmin
  const y = extent.ymax - extent.ymin
  extent.xmin = extent.xmin - x / 2
  extent.xmax = extent.xmax + x / 2
  extent.ymin = extent.ymin - y / 2
  extent.ymax = extent.ymax + y / 2
  return extent
}

export const charCount = (str: string) => {
  // 统计字母（包括大小写）
  const letters = (str.match(/[a-zA-Z]/g) || []).length

  // 统计数字
  const numbers = (str.match(/[0-9]/g) || []).length

  // 统计汉字
  const chinese = (str.match(/[\u4e00-\u9fa5]/g) || []).length

  // 统计其他字符（总长度减去上述三类）
  const others = str.length - letters - numbers - chinese

  return chinese + (letters + numbers + others) / 2
}
export default {
  isLoginIsAuthentication,
  downloadAttachment,
  setT026,
  beforeReadImg,
  beforeReadFile,
  secureCheck,
  errorList
}
